// @flow
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {getTierName} from '../../../store/utils/utils_tier';

/* import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IosSwitch from '../../../../elements/IosSwitch/IosSwitch';
 */
import type {
  Subscription,
  SubscriptionSetting,
  CardProfile,
  Store,
} from '../../../../entities';
import type {AccountConfigAction} from '../duck';
import {useCurrentSubscription} from '../../../tiers/utils';

type Props = {|
  store: Store,
  subscription?: Subscription,
  dueInformation?: Subscription,
  subscriptionSetting?: SubscriptionSetting,
  saveSubscriptionSetting: (payload: AccountConfigAction) => void,
  cardProfiles?: CardProfile[],
|};

const useStyles = makeStyles(theme => ({
  lineData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 'auto',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  columnData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: 'auto',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  root: {
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  label: {
    fontSize: '14px',
    color: colors.grey900,
    fontWeight: 600,
  },
  data: {
    fontSize: '14px',
    color: colors.grey700,
    fontWeight: 400,
  },
  card: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1.25px solid rgba(123, 57, 255, 0.5)',
    boxSizing: 'border-box',
    borderRadius: '8px',
  },
}));

export default function PaymentInformation(props: Props) {
  const {
    store,
    /*     cardProfiles,
    subscriptionSetting,
    saveSubscriptionSetting, */
    // dueInformation,
  } = props;
  const [tierName, setTierName] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [dueDate, setDueDate] = useState('');
  const classes = useStyles();
  const subscription = useCurrentSubscription();

  useEffect(() => {
    if (subscription) {
      const options = {
        month: 'long',
        day: 'numeric',
      };
      if (subscription.state === 'PENDING') {
        setEndDate(
          new Date(subscription.startDate).toLocaleDateString('es-ES', options)
        );
      } else
        setEndDate(
          new Date(subscription.endDate).toLocaleDateString('es-ES', options)
        );
      /* if (dueInformation && dueInformation.state === 'PENDING') {
        const paymentDueDate = new Date(dueInformation.paymentDueDate);
        setDueDate(paymentDueDate.toLocaleDateString('es-ES', options));
      } */
    } else {
      setEndDate('Indefinido');
    }
  }, [subscription]);

  useEffect(() => {
    if (store) {
      const tier = getTierName(store);
      setTierName(tier);
    }
  }, [store]);
  /* 
  const handleChangeSwitch = () => {
    if (typeof subscriptionSetting !== 'undefined')
      saveSubscriptionSetting({
        accountConfigRequest: {
          automaticCharge: !subscriptionSetting.automaticCharge,
        },
      });
  }; */

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.lineData} xs={12} sm={10} md={10}>
        <div className={classes.label}>Plan</div>
        <div className={classes.data}>{tierName}</div>
      </Grid>
      <Grid item className={classes.lineData} xs={12} sm={10} md={10}>
        <div className={classes.label}>Fecha de Vencimiento</div>
        <div className={classes.data}>{endDate}</div>
      </Grid>
      {/* {dueDate && (
        <Grid item className={classes.lineData} xs={12} sm={10} md={10}>
          <div className={classes.data}>Fecha máxima de pago</div>
          <div className={classes.data}>{dueDate}</div>
        </Grid>
      )} */}
      {/*      {cardProfiles &&
        cardProfiles.map((cardProfile: CardProfile, index: number) => (
          <Grid
            key={`card-profile-${index}`}
            item
            className={classes.columnData}
            xs={12}
            sm={10}
            md={10}
          >
            <div className={classes.label}>Tarjeta Guardada</div>
            <div className={classes.data}>
              <div className={classes.card}>
                <FormControlLabel
                  control={
                    <Radio color="primary" checked={cardProfile.current} />
                  }
                  label={
                    <div className={classes.label}>
                      {`${cardProfile.firstName} ${cardProfile.lastName}`}
                    </div>
                  }
                />
                <div
                  className={classes.lineData}
                >{`DNI: ${cardProfile.idNumber}`}</div>
                <div className={classes.lineData}>
                  {!!cardProfile.displayName &&
                    `Número de tarjeta: xxxx xxxx xxxx ${cardProfile.displayName.substring(
                      12,
                      16
                    )}`}
                </div>
              </div>
            </div>
          </Grid>
        ))} */}
      {/*       {!!cardProfiles && !!cardProfiles.length && (
        <Grid item className={classes.lineData} xs={12} sm={10} md={10}>
          <FormControlLabel
            value={
              !!subscriptionSetting
                ? subscriptionSetting.automaticCharge
                : false
            }
            control={
              <IosSwitch
                checked={
                  !!subscriptionSetting
                    ? subscriptionSetting.automaticCharge
                    : false
                }
                className={classes.switchContainer}
                onChange={() => handleChangeSwitch()}
                name="enabled"
              />
            }
            label={<div className={classes.label}>Renovación automática</div>}
            labelPlacement="start"
          />
        </Grid>
      )} */}
    </Grid>
  );
}

PaymentInformation.propTypes = {
  store: PropTypes.object.isRequired,
  subscription: PropTypes.object,
  dueInformation: PropTypes.object,
  subscriptionSetting: PropTypes.object,
  saveSubscriptionSetting: PropTypes.func,
  cardProfiles: PropTypes.array,
};
